"use client";

import type { ReactNode } from "react";
import type { LeadFlowRuntimeValues } from "../types";

import { createContext, useContext } from "react";

const LeadFlowRuntimeContext = createContext<LeadFlowRuntimeValues | null>(
  null,
);

type LeadFlowRuntimeProviderProps = {
  children: ReactNode;
  value: LeadFlowRuntimeValues;
};

function LeadFlowRuntimeProvider({
  children,
  value,
}: LeadFlowRuntimeProviderProps) {
  return (
    <LeadFlowRuntimeContext.Provider value={value}>
      {children}
    </LeadFlowRuntimeContext.Provider>
  );
}

function useLeadFlowRuntime(): LeadFlowRuntimeValues {
  const runtimeValues = useContext(LeadFlowRuntimeContext);
  if (!runtimeValues) {
    throw new Error(
      "useLeadFlowRuntime must be used within LeadFlowRuntimeProvider",
    );
  }
  return runtimeValues;
}

export { LeadFlowRuntimeProvider, useLeadFlowRuntime };
